import { Component, input, output } from '@angular/core';
import { FormGroup, FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { DataValidation, TemplateSlot } from '../../../interfaces';
import { SlotType } from '../../../enums';
import { SlotAddressAutocompleteInputComponent } from '../slot-address-autocomplete-input/slot-address-autocomplete-input.component';
import { SlotTypeCssClassPipe, TargetSlotValidationsPipe } from '../../../pipes';

@Component({
    selector: 'ca-template-combined-slot',
    templateUrl: './template-combined-slot.component.html',
    styleUrls: ['./template-combined-slot.component.scss'],
    imports: [FormsModule, TranslateModule, SlotAddressAutocompleteInputComponent, SlotTypeCssClassPipe, TargetSlotValidationsPipe]
})
export class TemplateCombinedSlotComponent {
    readonly slotType = SlotType;
    slots = input.required<TemplateSlot[]>();
    questionBlockId = input.required<string>();
    questionBlockValidations = input<DataValidation[]>();
    devMode = input<boolean>(false);
    form = input.required<FormGroup>();
    markAsTouched = input<boolean>(false);
    value = input.required<any>();
    valueChange = output<{ slot: TemplateSlot; value: any }>();

    onValueChange(slots: TemplateSlot[], combinedValue: any): void {
        slots.forEach(slot => {
            const slotValue = { slot, value: combinedValue?.[slot.id] };
            this.valueChange.emit(slotValue);
        });
    }
}
